import { useLiveQuery } from 'dexie-react-hooks';
import { useTranslation } from '@/shared/i18n/use-translation';
import { formatTimestamp } from '@/shared/lib/dates/format-timestamp';
import { replica } from '@/shared/sync/replica';
import { Button } from '@/shared/ui/button/button';

export function RejectionsNotice() {
  const { t, tn } = useTranslation();
  const rejections = useLiveQuery(() => replica.db.rejections.orderBy('at').reverse().toArray());
  if (!rejections?.length) return null;
  return (
    <div className="flex flex-col gap-2 rounded-lg border border-warn/40 bg-warn/10 p-3">
      <span className="text-sm font-medium">
        {tn(
          rejections.length,
          '{count} change refused by the server',
          '{count} changes refused by the server',
        )}
      </span>
      <ul className="flex flex-col gap-1 text-sm text-muted-foreground">
        {rejections.slice(0, 10).map((rejection) => (
          <li key={rejection.op_id}>
            {formatTimestamp(rejection.at)} ·{' '}
            {rejection.code === 'sync.record_deleted' ? t('the record had been deleted') : rejection.message}
          </li>
        ))}
      </ul>
      <Button
        variant="ghost"
        size="sm"
        className="self-start"
        onClick={() => void replica.db.rejections.clear()}
      >
        {t('Got it, clear the notice')}
      </Button>
    </div>
  );
}
